import css from 'styled-jsx/css'

import { colors } from '../../theme'
import common from '../../theme/common'


export default css`
  .container {
    ${common.small};

    font-family: 'Open Sans Bold', sans-serif;
    text-align: center;
    transition: background-color 150ms ease-out, opacity 50ms ease-out;
    background-color: transparent;
    cursor: pointer;
    margin: 0.2rem 0.4rem;
  }

  .container:hover {
    background-color: ${colors.governorBayBlue};
  }

  .container:active {
    opacity: 0.6;
  }

  .container :global(a) {
    border: 1px solid ${colors.governorBayBlue};
    text-decoration: none;
    color: ${colors.governorBayBlue};
    transition: color 150ms ease-out;
    padding: 1.5rem 3rem;
  }

  .container:hover :global(a) {
    color: ${colors.pureWhite};
  }
`
